import * as React from "react";
const SvgFiRrKeynote = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-keynote_svg__a)">
      <path
        fill="#062147"
        d="M23 16h-.28l-.86-2.582A4.99 4.99 0 0 0 17.117 10H6.883q-.45.001-.883.079V7c0-1.654 1.346-3 3-3h.172A3.005 3.005 0 0 0 12 6h3c1.654 0 3-1.346 3-3s-1.346-3-3-3h-3a3.005 3.005 0 0 0-2.828 2H9C6.243 2 4 4.243 4 7v3.914a5 5 0 0 0-1.861 2.505L1.28 16h-.279a1 1 0 1 0 0 2H11v4H8a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-3v-4h10a1 1 0 1 0 0-2M12 2h3a1.001 1.001 0 0 1 0 2h-3a1.001 1.001 0 0 1 0-2M4.036 14.051A3 3 0 0 1 6.883 12h10.234c1.293 0 2.437.824 2.847 2.051L20.613 16H3.387z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-keynote_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrKeynote;
